import {CrudApiService} from "@/services/api/api.base.js";
import JwtService from "@/services/jwt.service";

export class AuthApiService extends CrudApiService {
  constructor(resource, notifier, errcallback) {
    super(resource, notifier, errcallback);
  }

  setAuthHeader() {  
    const token = JwtService.getToken();
    this.header.common["Authorization"] = token
      ? `Bearer ${token}`
      : "";
  }

  async login(params) {
    const data  = await super.post("login", params);
    return data;
  }

  async logout() {
    const data  = await super.delete("logout");
    return data;
  }

  async getMe() {
    const data = await super.get("user_data");
    return data;
  }
}